import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminTab } from '.';
import { Tabs, TabsContent } from '../../components/Tabs';
import { Route } from '../../constants';
import { ClinicsList } from './ClinicsList';
import { LifeglovLinerStockList } from './LifeglovLinerStockList';
import { UsersList } from './UsersList';

export function Admin() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = Object.values(AdminTab).find((tab) => location.pathname.endsWith(tab)) ?? AdminTab.Clinics;

  const onTabChange = useCallback(
    (tab: string) => {
      navigate(`${Route.Admin}/${tab}`, { replace: true });
    },
    [navigate]
  );

  return (
    <Tabs defaultValue={activeTab} onValueChange={onTabChange} className="flex-1 flex-col">
      <TabsContent value={AdminTab.Users}>
        <UsersList />
      </TabsContent>

      <TabsContent value={AdminTab.Clinics}>
        <ClinicsList />
      </TabsContent>

      <TabsContent value={AdminTab.LifeglovLinerStock}>
        <LifeglovLinerStockList />
      </TabsContent>
    </Tabs>
  );
}
